module.exports = __webpack_public_path__ + "img/01_abe_18.74af6bef.jpg";